import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";

import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { reExportServicePackTranslation } from "../../api/reExportServicePackTranslation";

export function useReExportServicePack() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reExportServicePackTranslation,
    onSuccess: (response) => {
      toast.success("Re Extraction started successfully");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
